"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _path = _interopRequireDefault(require("path"));
var _permission = require("@/utils/permission");
var role = _interopRequireWildcard(require("@/api/role"));
var _router = require("@/router");
var _AddRole = _interopRequireDefault(require("./components/AddRole.vue"));
var _vuePropertyDecorator = require("vue-property-decorator");
var RoleComponent = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(RoleComponent, _Vue);
  var _super = (0, _createSuper2.default)(RoleComponent);
  function RoleComponent() {
    var _this;
    (0, _classCallCheck2.default)(this, RoleComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogLoading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "role", {
      name: "",
      permissions: [],
      description: ""
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tableLoading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "routes", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rolesList", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogVisible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogType", "new");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkStrictly", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingUpdate", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "permissionsList", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultProps", {
      children: "children",
      label: "title"
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingImport", false);
    return _this;
  }
  (0, _createClass2.default)(RoleComponent, [{
    key: "defaultCheck",
    get: function get() {
      var res = [];
      if (this.role) this.role.permissions.forEach(function (element) {
        res.push(element.path);
      });
      return res;
    }
  }, {
    key: "created",
    value: function created() {
      this.getRoutes();
      this.getRoles();
      this.getAllPermission();
    }
  }, {
    key: "getAllPermission",
    value: function getAllPermission() {
      var _this2 = this;
      role.getPermissions().then(function (res) {
        _this2.permissionsList = res.data;
      });
    }
  }, {
    key: "importRoutesPath",
    value: function importRoutesPath() {
      var _this3 = this;
      var routes = (0, _permission.generateRoutesPath)();
      var permissions = [];
      routes.forEach(function (e) {
        var basePath = e.path;
        if (e.children) {
          e.children.forEach(function (child) {
            var pathRoute = _path.default.resolve(basePath, child.path);
            var route = _this3.permissionsList.find(function (r) {
              return r.path == pathRoute;
            });
            if (!route) {
              permissions.push({
                path: pathRoute
              });
            }
          });
        }
      });
      var data = {
        permissions: permissions
      };
      this.loadingImport = true;
      role.importRoutesPath(data).then(function () {
        _this3.$message({
          type: "success",
          message: "Cập nhật menu thành công"
        });
      }).finally(function () {
        return _this3.loadingImport = false;
      });
    }
  }, {
    key: "getRoutes",
    value: function getRoutes() {
      this.routes = this.generateRoutes(_router.constantRoutes);
    }
  }, {
    key: "getRoles",
    value: function () {
      var _getRoles = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.tableLoading = true;
                _context.next = 3;
                return role.getRoles();
              case 3:
                res = _context.sent;
                this.tableLoading = false;
                this.rolesList = res.data;
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getRoles() {
        return _getRoles.apply(this, arguments);
      }
      return getRoles;
    }() // Reshape the routes structure so that it looks the same as the sidebar
  }, {
    key: "generateRoutes",
    value: function generateRoutes(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var res = [];
      var _iterator = (0, _createForOfIteratorHelper2.default)(routes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var route = _step.value;
          // skip some route
          if (route.hidden || route.meta && !route.meta.permission) {
            continue;
          }
          var data = {
            path: _path.default.resolve(basePath, route.path),
            title: route.meta && route.meta.title
          };
          // recursive child routes
          if (route.children) {
            data.children = this.generateRoutes(route.children, data.path);
          }
          res.push(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return res;
    }
  }, {
    key: "handleEdit",
    value: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(row) {
        var _this4 = this;
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialogType = "edit";
                this.dialogVisible = true;
                this.dialogLoading = true;
                _context2.next = 5;
                return role.getPermission(row.id);
              case 5:
                res = _context2.sent;
                this.dialogLoading = false;
                this.role = res.data;
                this.checkStrictly = false;
                this.$nextTick(function () {
                  _this4.checkStrictly = true;
                });
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }()
  }, {
    key: "confirmRole",
    value: function confirmRole() {
      var _this5 = this;
      var permissionsCheck = this.$refs["tree"].getCheckedNodes();
      var res = this.permissionsList.filter(function (item) {
        return permissionsCheck.some(function (per) {
          return item.path == per.path;
        });
      });
      var permissionIds = res.map(function (e) {
        return e.id;
      });
      var data = {
        permissionIds: permissionIds,
        info: {
          name: this.role.name,
          description: this.role.description
        }
      };
      this.loadingUpdate = true;
      role.updatePermission(this.role.id, data).then(function (res) {
        _this5.dialogVisible = false;
        _this5.$notify.success({
          message: "Thành công",
          type: "success",
          title: "Thông báo"
        });
      }).finally(function () {
        _this5.loadingUpdate = false;
      });
    }
  }]);
  return RoleComponent;
}(_vuePropertyDecorator.Vue);
RoleComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddRole: _AddRole.default
  }
})], RoleComponent);
var _default = RoleComponent;
exports.default = _default;